import { get, pick } from 'lodash';
import type { ComponentType } from 'react';
import React from 'react';
import { connect } from 'react-redux';

import type { Props as IframeProps } from '@swf/components/Iframe/Iframe';
import Iframe from '@swf/components/Iframe/Iframe';
import type { FetchTagPayload } from '@swf/core/models/resolver';
import type { AuthenticatedSession } from '@swf/core/models/session';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

type OwnProps = {
  tag: string | FetchTagPayload;
  query?: object;
  mitIdData?: object;
} & IframeProps;

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = ReturnType<typeof mapDispatch>;
export type Props = OwnProps & StateProps & DispatchProps;

class ResolverIframe extends React.PureComponent<Props> {
  componentDidMount() {
    this.fetchTag();
  }

  componentDidUpdate({ tag }: Props) {
    if (tag !== this.props.tag) {
      this.fetchTag();
    }
  }

  fetchTag() {
    const query = {
      ...pick(this.props, ['language', 'country', 'site', 'platform', 'userId', 'timezone']),
      ...this.props.query,
      ...this.props.mitIdData,
      TimeZoneId: this.props.timezone,
      u: this.props.userWebId // Must be a last for license migration app
    };
    const payload = typeof this.props.tag === 'string' ? { tag: this.props.tag } : this.props.tag;
    payload.query = query;
    this.props.fetchTag(payload);
  }

  render() {
    if (!this.props.url) {
      return null;
    }

    const {
      country,
      fetchTag,
      language,
      platform,
      url,
      site,
      timezone,
      userId,
      userWebId,
      mitIdData,
      ...props
    } = this.props;

    return <Iframe src={url} {...props} />;
  }
}

const mapState = (rootState: RootState, ownProps: OwnProps) => {
  const { userWebId } = select.session.get(rootState) as AuthenticatedSession;
  const language = select.locale.get(rootState);
  const { userId, country, timezone } = select.account.get(rootState);
  const resolvedTag = select.resolver.getTag(
    rootState,
    get(ownProps, ['tag', 'tag'], ownProps.tag)
  );
  const site = select.site.getName(rootState);
  const platform = 'Web';
  const url = resolvedTag ? decodeURIComponent(resolvedTag.url) : null;

  return { url, userWebId, language, userId, country, timezone, site, platform };
};

const mapDispatch = ({ resolver: { fetchTag } }: Dispatch) => ({ fetchTag });

// @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
export default connect(mapState, mapDispatch)(ResolverIframe) as ComponentType<OwnProps>;
